import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SignInComponent from "../../../Component/ReusableComponent/LandingPage/LandingPage";
import { KioskAuthContext } from "../../../ContextAPI/KisokContext";
import "./Login.css";

export default function FliplynSignInPage() {

  const navigate = useNavigate();
  const { token, login } = useContext(KioskAuthContext);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [formError, setFormError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (token) {
      navigate("/user");
    }
  }, [token, navigate]);

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleLogin = async () => {

    setFormError("");

    if (!email) return setFormError("Email is required");
    if (!validateEmail(email)) return setFormError("Enter valid email");
    if (!password) return setFormError("Password is required");
    if (password.length < 6)
      return setFormError("Password must be at least 6 characters");

    try {

      setLoading(true);

      await login(email, password);

      navigate("/user");

    } catch (error) {

      setFormError(error.message);

    } finally {

      setLoading(false);

    }
  };

  return (
    <SignInComponent
      className="fliplyn-theme"
      appName="Fliplyn"
      tagline="FAST • FRESH • FRIENDLY"
      email={email}
      password={password}
      setEmail={setEmail}
      setPassword={setPassword}
      formError={formError}
      loading={loading}
      onSubmit={handleLogin}
    />
  );
}